const className = (...arr) => arr.filter(a => a).join(' ')

export default className